module.exports = __webpack_public_path__ + "img/0-17.73de365e.jpg";